import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ExoStar } from 'src/app/models/ExoStar';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IAttributes } from 'src/app/models/IAttributes';
import { ActivatedRoute } from '@angular/router';
import { ExoStarService } from 'src/app/Services/ExoStar/exo-star.service';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { ExostarTransaction } from 'src/app/models/ExoStarTransaction';
import { ToastrService } from 'ngx-toastr';
import { DatePipe, formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputDialogComponent } from 'src/app/ChildControls/input-dialog/input-dialog.component';
import { EXOAuthTransaction } from 'src/app/models/EXOAuthTransaction';

export interface Prescription {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-manage-exo-star-user',
  templateUrl: './manage-exo-star-user.component.html',
  styleUrls: ['./manage-exo-star-user.component.css']
})

export class ManageExoStarUserComponent implements OnInit {

  userId: string;
  userstatus: string;
  status: string;
  grant: boolean;
  fullName: string;
  modified: Date;
  comment: string;
  providerId: string;
  hideProofing: boolean = true;
  resume: boolean = false;
  remark: boolean = true;
  userDetails: ExoStar;
  ManageEpcsRegistration: FormGroup;
  proofType: IAttributes[];
  lstTokentype: IAttributes[] = [];
  lstattrbutes: IAttributes[] = [];
  Prescriptions: Prescription[] = [
    { value: '10', viewValue: '10' },
    { value: '20', viewValue: '20' },
    { value: '30', viewValue: '30' },
    { value: '40', viewValue: '40' },
    { value: '50', viewValue: '50' },
    { value: '60', viewValue: '60' },
    { value: '70', viewValue: '70' },
    { value: '80', viewValue: '80' },
    { value: '90', viewValue: '90' },
    { value: '100', viewValue: '100' }
  ];
  failed: boolean = false;
  wait: boolean = false;
  web: boolean = false;
  DeactivedisableBtn: boolean = false;
  constructor(private route: ActivatedRoute, private router: Router, public dialog: MatDialog, private ExoStarServices: ExoStarService, private crypto: AESAlgorithm,
    private formBuilder: FormBuilder, private toastr: ToastrService, public datepipe: DatePipe,) { }


  ngOnInit() {
    if (sessionStorage.getItem("ExoUserId") != null && sessionStorage.getItem("ExoUserId") != undefined)
      this.userId = sessionStorage.getItem("ExoUserId").toString();
    else
      this.userId = this.route.snapshot.paramMap.get('userId');
    this.userstatus = this.route.snapshot.paramMap.get('userstatus');

    sessionStorage.setItem("ExoUserId", this.userId);
    sessionStorage.setItem("ExoUserStatus", this.userstatus);
    if (this.userstatus != "ACTIVE") {
      this.DeactivedisableBtn = false;
    }
    else {
      this.DeactivedisableBtn = true;
    }
    this.getUserDetails();
    this.getProofType();
    this.ManageEpcsRegistration = this.formBuilder.group({
      firstName: [''],
      middleName: [''],
      lastName: [''],
      dob: [''],
      ssn: [''],
      NPI: [''],
      remarks: [''],
      providerId: [''],
      address1: [''],
      address2: [''],
      phone: [''],
      email: [''],
      type: [''],
      product: [''],
      license: [''],
      SoftTokens: [''],
      HardTokens: [''],
      licenseExpiry: [''],
      proofingStart: [''],
      proofingEnd: [''],
      proofType: [''],
      tokentype: [''],
      MaxPrescption: ['']
    })
    this.getTokens();
    this.FetchOptionsData();
  }

  getProofType() {
    this.ExoStarServices.getAttributes('Proof_Type').subscribe(data => {
      this.proofType = data;
    })
  }
  getTokens() {
    this.ExoStarServices.getMasterData().subscribe((data: IAttributes[]) => {
      this.lstattrbutes = data;
      this.lstTokentype = this.lstattrbutes.filter((attr: IAttributes) => attr.attributeType == 'Tokentype');
    })
  }
  onTokenChange(event) {
    var userid = this.userId;
    var token = event.target.value;
    this.ExoStarServices.updateExostardefaultOptionDetails(userid, token).subscribe(
      results => {
        this.toastr.success(results);
        this.FetchOptionsData();
      }, (err: any) => {
        console.log(err);
      });
  }
  onPrescriptionChange(event) {
    var userid = this.userId;
    var prescription = event.target.value;
    this.ExoStarServices.updateExostarPrescriptionDetails(userid, prescription).subscribe(
      results => {
        this.toastr.success(results);
        this.FetchOptionsData();
      }, (err: any) => {
        console.log(err);
      });
  }


  FetchOptionsData() {
    this.ExoStarServices.GetExoStarOptionsDetails(this.userId).subscribe((data: IAttributes) => {
      // this.lstattrbutes = data;
      this.ManageEpcsRegistration.patchValue({
        tokentype: data.attributeId
      });
    }, (err: any) => {
      console.log(err);
    });
  }
  getUserDetails() {
    this.ExoStarServices.manageExoStarDetails(this.userId).subscribe(data => {
      this.userDetails = data;

      if (this.userDetails.proofingStart != null && this.userDetails.proofingStart != undefined) {
        //  var effDate = this.datepipe.transform(this.userDetails.proofingStart, 'MM/dd/yyyy  hh:mm a' );
        var proofinfstartDate = formatDate(this.userDetails.proofingStart, 'MM/dd/yyyy  hh:mm a', 'en-US', 'locale');
      } else {
        var proofinfstartDate = this.userDetails.proofingStart;
      }
      if (this.userDetails.proofingEnd != null && this.userDetails.proofingEnd != undefined) {
        //  var effDate = this.datepipe.transform(this.userDetails.proofingStart, 'MM/dd/yyyy  hh:mm a' );
        var proofinfEndDate = formatDate(this.userDetails.proofingEnd, 'MM/dd/yyyy  hh:mm a', 'en-US', 'locale');
      } else {
        var proofinfEndDate = this.userDetails.proofingEnd;
      }



      if (this.userDetails != null && this.userDetails != undefined) {
        this.ManageEpcsRegistration.patchValue({
          firstName: this.userDetails.firstName,
          lastName: this.userDetails.lastName,
          middleName: this.userDetails.middleName,
          providerId: this.userDetails.providerId,
          address1: this.userDetails.fullAddress,
          address2: this.userDetails.address2,
          license: this.userDetails.licenseKey,
          dob: this.userDetails.dob,
          ssn: this.userDetails.ssn,
          mobile: this.userDetails.phone,
          email: this.userDetails.emailId,
          phone: this.userDetails.phone,
          product: this.userDetails.Notes,
          NPI: this.userDetails.NPI,
          licenseExpiry: this.userDetails.licenseExpiry,
          SoftTokens: this.userDetails.SoftTokens,
          HardTokens: this.userDetails.HardTokens,
          proofingStart: proofinfstartDate,
          proofingEnd: proofinfEndDate,
          proofType: this.userDetails.proofingType,
          remarks: this.userDetails.remarks,
          MaxPrescption: this.userDetails.prescriptionLimit
        })
        this.status = this.userDetails.proofStatus;
        this.fullName = this.userDetails.fullName;
        this.modified = this.userDetails.modifiedOn;
        if (this.status == "ACTIVE") {
          this.hideProofing = false;
          this.remark = false;
        }
        else if (this.status == "RESUME") {
          this.hideProofing = false;
          this.resume = true;
        }
        else if (this.status == "FAILED" || this.status == "DEAD") {
          this.hideProofing = false;
          this.failed = true;
        }
        else if (this.status == "WAITING FOR PROOFER") {
          this.ManageEpcsRegistration.patchValue({
            proofType: ' WEBCAM'
          });
          this.hideProofing = false;
          this.web = false;
          this.wait = true;
        }
      }
      if (this.userDetails != null && this.userDetails != undefined) {
        this.grant = this.userDetails.grantAccess;
        if (this.userDetails.proofingType == "WEBCAM" && this.userDetails.proofStatus == "DEAD") {
          this.hideProofing = false;
          if (this.status == "WAITING FOR PROOFER")
            this.web = false;
          else if (this.status == "DEAD")
            this.web = false;
          else if (this.status != "RESUME")
            this.web = true;
        }
        else if (this.userDetails.proofingType == "WEBCAM" && this.userDetails.proofStatus == "FAILED") {
          this.hideProofing = false;
          this.web = true;
          this.failed = false;
        }
      }

    })
  }

  resumeProofing() {
    var userObj = new ExoStar();
    userObj.providerId = this.userDetails.providerId;
    userObj.activationCode = sessionStorage.getItem("FacilityId").toString();

    this.ExoStarServices.resumeProofing(userObj).subscribe(
      results => {
        this.processResponse(results);
      }, (err: any) => {
        console.log(err);
      });
  }

  startProofing() {

    if (this.userDetails.proofingType == "WEBCAM") {
      this.webcamProofing();
    }
    else {
      this.ExoStarServices.initiateProofing(this.userId).subscribe(data => {
        this.processResponse(data)
      });
    }

  }

  processResponse(transaction: ExostarTransaction) {
    if (transaction != null && transaction != undefined) {
      if (transaction.transactionStatus == 'SUCCESS') {
        if (transaction.status == 'wtg_redirect')
          this.goToUrl(transaction.response);
        else
          this.toastr.success(transaction.response);
      }
      else if (transaction.transactionStatus == 'FAILURE')
        this.toastr.error(transaction.response);
      else if (transaction.status == 'wtg_resume')
        this.goToUrl(transaction.response);
    }
  }
  goToUrl(url: any): void {
    document.location.href = url;
  }
  @Output() backtoEps = new EventEmitter();
  onClickEpcsconsole() {
    this.router.navigate(['EpcsConsole'], { queryParams: { isepcs: true } });
    this.backtoEps.emit()
  }


  webcamProofing() {
    this.ExoStarServices.initiateWebProofing(this.userId).subscribe(data => {
      this.processResponse(data)
    });
  }

  ScheduleAppointment() {
    // document.location.href ='https://portal.exostartest.com/l3xopbcalendar';
    // window.open('https://portal.exostartest.com/l3xopbcalendar','_blank');

    var FacilityId = Number(sessionStorage.getItem("FacilityId").toString());
    this.ExoStarServices.getScheduleWebCamNavigateUrl(FacilityId).subscribe(
      results => {
        window.open(results.toString(), "_blank");
      }, (err: any) => {
        console.log(err);
      });

  }
  openDialogs(element: ExoStar): void {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '350px',
      height: '160px',
      data: { headerText: 'Please enter the comment', inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
        this.comment = result;
        this.providerId = this.userDetails.providerId;
        this.ExoStarServices.DeactiveexostarUsers(this.comment, this.providerId).subscribe(
          results => {
            if (results.transactionStatus = 'SUCCESS')
              this.getUserDetails();
            else
              this.toastr.success("Unable to deactivate");

          }, (err: any) => {
            console.log(err);
          });
      }
    });
  }

  LaunchSession() {
    var transaction = new EXOAuthTransaction();
    transaction.loggedInUser = sessionStorage.getItem("userId").toString();
    transaction.providerId = this.userDetails.providerId;
    transaction.userId = this.userDetails.userId;
    transaction.facilityId = Number(sessionStorage.getItem("FacilityId").toString());
    this.ExoStarServices.launchSession(transaction).subscribe(
      (results: ExostarTransaction) => {
        if (results.transactionStatus == 'FAILURE')
          this.toastr.error(results.response);
        else
          window.open(results.response, "_blank");

      });
  }


}

